(() => {
  const dialog = document.getElementById('FinishedSetInterest');
  if (!dialog) return;
  const close = dialog.querySelector('[data-interest-close]');
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  // Shopify may show its security check outside the dialog's top layer.
  // Let that native check receive focus instead of hiding it behind the modal.
  dialog.querySelector('form').addEventListener('submit', () => {
    if (dialog.open) dialog.close();
    let status = document.getElementById('FinishedSetSubmitting');
    if (!status) {
      status = document.createElement('p');
      status.id = 'FinishedSetSubmitting';
      status.setAttribute('role', 'status');
      status.className = 'lind-choice-small';
      status.append('Please complete any security check shown. Your interest is registered only when Shopify confirms it. ');
      const reopen = document.createElement('button');
      reopen.type = 'button';
      reopen.className = 'lind-interest-open';
      reopen.textContent = 'Return to the interest form';
      reopen.addEventListener('click', () => dialog.showModal());
      status.append(reopen);
      document.querySelector('.lind-finished-interest')?.append(status);
    }
  });
  function mount() {
    if (!location.pathname.replace(/\/$/, '').endsWith('/products/lindsay-system-scottish-smallpipes')) return;
    const payment = document.getElementById('payment');
    const order = document.getElementById('addToBag');
    if (!payment || !order || payment.dataset.orderChoiceReady) return;
    payment.dataset.orderChoiceReady = 'true';
    const note = document.createElement('aside');
    note.className = 'lind-order-choice';
    note.setAttribute('aria-label', 'Payment options');
    note.innerHTML = '<strong>Order with a 50% deposit</strong><p>Pay the balance when your pipes are finished, before dispatch. Shipping and any agreed extras are confirmed separately.</p><button type="button" class="lind-deposit-choice">Choose 50% deposit</button>';
    payment.closest('label').before(note);
    const choose = note.querySelector('button');
    const update = () => {
      const selected = payment.value === 'deposit';
      choose.textContent = selected ? '50% deposit selected' : 'Choose 50% deposit';
      choose.disabled = selected;
    };
    choose.addEventListener('click', () => {
      payment.value = 'deposit';
      payment.dispatchEvent(new Event('change', { bubbles: true }));
      update();
    });
    payment.addEventListener('change', update);
    update();
    const interest = document.createElement('div');
    interest.className = 'lind-finished-interest';
    interest.innerHTML = '<p><strong>Prefer to wait for a finished set?</strong></p><p>Register your interest without paying a deposit.</p><button type="button" class="lind-interest-open">Let me know when a set is ready</button><p class="lind-choice-small">No payment or commitment. Availability will depend on the sets Donald completes.</p>';
    order.closest('form') ? order.closest('form').after(interest) : order.after(interest);
    interest.querySelector('button').addEventListener('click', () => {
      const variant = document.getElementById('variant');
      const configuration = dialog.querySelector('[name="contact[Configuration of interest]"]');
      if (configuration && variant) configuration.value = variant.selectedOptions[0]?.textContent || '';
      dialog.showModal();
    });
  }
  new MutationObserver(mount).observe(document.body, { childList: true, subtree: true });
  mount();
  if (new URLSearchParams(location.search).get('contact_posted') === 'true' && location.hash === '#FinishedSetInterestForm') {
    const form = dialog.querySelector('form');
    form.replaceChildren();
    const receipt = document.createElement('p');
    receipt.setAttribute('role', 'status');
    receipt.textContent = 'Thank you. Shopify has accepted your enquiry. There is nothing to pay now.';
    form.append(receipt);
    dialog.dataset.response = 'true';
  }
  if (dialog.dataset.response === 'true') dialog.showModal();
})();
